import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InteractiveElement } from "@iventis/styles/src/components";
import { media, EmphasisText, styled } from "@iventis/styles";

export const StyledEllipsis = styled(FontAwesomeIcon)`
    align-self: center;
    width: 100%;
`;

export const StyledNameContainer = styled.div`
    flex-basis: 80%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-width: 0;
    .icon {
        flex: 0 0 30px;
    }
    ${media.extraSmall} {
        flex-basis: 90%;
    }
    ${media.small} {
        flex-basis: 70%;
    }
    ${media.medium} {
        flex-basis: 90%;
    }
    ${media.large} {
        flex-basis: 70%;
    }
`;

export const StyledNodeName = styled(InteractiveElement)<{ selected?: boolean; isNameClickable?: boolean }>`
    ${(props) => props.selected && "font-weight: bold;"}

    text-align: left;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    :hover {
        ${(props) => (props.isNameClickable ? "text-decoration: underline" : "cursor: default")};
    }
`;

export const StyledEmptyNodeMessage = EmphasisText;
